"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileListSearchBar = exports.onKeyPress = exports.onSearchStringChange = exports.onDropdownCadetClick = void 0;
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var React = require("react");
var recompose_1 = require("recompose");
var react_router_dom_1 = require("react-router-dom");
var AdvancedSearchDropdownContainer_1 = require("./AdvancedSearchDropdownContainer");
var SearchBoxLeft_1 = require("./SearchBoxLeft");
var SearchBoxRight_1 = require("./SearchBoxRight");
var ProjectSelector_1 = require("components/ProjectSelector");
var FileIcon_1 = require("components/FileIcon");
var sok_ui_1 = require("@caddigital/sok-ui");
var components_1 = require("components");
var fp = require("fp-ts");
require("./index.scss");
var types = [
    'PDF',
    'TEXT',
    'SPREADSHEET',
    'PRESENTATION',
    'IMAGE',
    'DWG',
    'IFC',
    'VIDEO',
    'FOLDER',
    'ADVANCED_SEARCH'
];
var onDropdownCadetClick = function (props) { return function (e) {
    e.preventDefault();
    e.stopPropagation();
    props.toggleAdvancedSearchDropdown();
}; };
exports.onDropdownCadetClick = onDropdownCadetClick;
var onSearchStringChange = function (searchString, props) {
    props.setInputValue(searchString);
};
exports.onSearchStringChange = onSearchStringChange;
var onKeyPress = function (props) { return function (event) {
    if (event.key === 'Enter') {
        props.onSearchFiles(__assign(__assign({}, props.searchOptions), { searchString: props.inputValue }));
        event.target.blur();
        if (props.searchDropdownToggled) {
            props.toggleSearchDropdown();
        }
    }
}; };
exports.onKeyPress = onKeyPress;
var enhance = (0, recompose_1.compose)((0, recompose_1.withState)('inputValue', 'setInputValue', ''), (0, recompose_1.withState)('width', 'setWidth', 0), (0, recompose_1.lifecycle)({
    componentWillMount: function () {
        this.props.setInputValue(this.props.searchOptions.searchString);
    },
    componentDidUpdate: function (prevProps) {
        if (this.props.inputValue !== prevProps.inputValue) {
            if (!this.props.searchDropdownToggled &&
                this.props.inputValue &&
                this.props.inputValue.length >= 3) {
                this.props.toggleSearchDropdown();
            }
        }
        if (this.props.searchOptions.searchString !== this.props.inputValue &&
            this.props.searchOptions.searchString !==
                prevProps.searchOptions.searchString) {
            this.props.setInputValue(this.props.searchOptions.searchString);
        }
        if (this.props.currentFolder !== prevProps.currentFolder) {
            if (this.props.searchDropdownToggled === true) {
                this.props.toggleSearchDropdown();
            }
            if (this.props.advancedSearchDropdownToggled === true) {
                this.props.toggleAdvancedSearchDropdown();
            }
        }
        if (this.props.searchDropdownToggled === true &&
            this.props.inputValue !== prevProps.inputValue &&
            this.props.inputValue.length >= 3) {
            var search = __assign(__assign({}, this.props.searchOptions), { searchString: this.props.inputValue });
            if (this.props.currentFolder) {
                this.props.onQuickSearchFiles(this.props.currentFolder.id, this.props.sortByOptions, search);
            }
        }
    }
}), recompose_1.pure);
var sortQuickSearch = function (a, b) {
    if (a.type !== b.type) {
        if (a.type === 'FOLDER') {
            return -1;
        }
        else if (b.type === 'FOLDER') {
            return 1;
        }
    }
    return a.name.localeCompare(b.name);
};
var AdvancedDropdown = function (props) { return (React.createElement(React.Fragment, null,
    React.createElement(AdvancedSearchDropdownContainer_1.AdvancedSearchDropdownContainer, { setSearchString: props.setSearchString, searchDropdownToggled: props.advancedSearchDropdownToggled, toggleSearchDropdown: props.toggleSearchDropdown, toggleAdvancedSearchDropdown: props.toggleAdvancedSearchDropdown, toggleMoreSearch: props.toggleMoreSearch, onResetSearchOptions: props.onResetSearchOptions, searchOptions: props.searchOptions, onSearchFiles: props.onSearchFiles, setSearchType: props.setSearchType, onLimitToFolder: props.onLimitToFolder, topLevelFolders: props.topLevelFolders, setContentSearch: props.setContentSearch, metadata: props.metadata, clearAll: props.clearAll }))); };
var enhanceSearchDropdown = (0, recompose_1.compose)((0, recompose_1.withState)('options', 'setOptions', []), (0, recompose_1.lifecycle)({
    componentDidMount: function () {
        var options = [
            {
                value: 'ANY',
                text: (0, translation_1.getLocalization)('userfront/project/files/targetYourSearch/AdvancedSearchDropdownContainer/moreSearchTools/label/type/placeHolder/any')
            }
        ].concat(types
            .filter(function (type) { return type !== 'ADVANCED_SEARCH'; })
            .map(function (type) {
            var ico = (0, FileIcon_1.typeToIconAndTextMap)(type);
            return {
                value: type,
                text: ico.text,
                leftComponent: ico.icon
            };
        }));
        this.props.setOptions(options);
    },
    shouldComponentUpdate: function (nextProps) {
        if (this.props.options !== nextProps.options ||
            this.props.searchDropdownToggled !== nextProps.searchDropdownToggled ||
            this.props.advancedSearchDropdownToggled !==
                nextProps.advancedSearchDropdownToggled) {
            return true;
        }
        return false;
    }
}), recompose_1.pure);
var SearchDropdown = enhanceSearchDropdown(function (props) {
    var selected = props.searchOptions.searchFileType.fold(undefined, function (e) { return (0, FileIcon_1.typeToIconAndTextMap)(e); });
    return (React.createElement(React.Fragment, null,
        props.options.map(function (item, index) { return (React.createElement(sok_ui_1.Dropdown2MenuItem, { key: "".concat(item.value, "-").concat(index), onClick: function (e) {
                e.preventDefault();
                e.stopPropagation();
                if (props.searchDropdownToggled) {
                    props.toggleSearchDropdown();
                }
                if (item.value === 'ANY') {
                    return props.setSearchType(fp.option.none);
                }
                return props.setSearchType(fp.option.some(item.value));
            } },
            React.createElement("div", { className: selected && selected.value === item.value ? 'active' : '' },
                React.createElement("span", { style: { marginRight: '0.8rem' } }, item.leftComponent),
                React.createElement("label", null, item.text)))); }),
        React.createElement(sok_ui_1.ClickWall, null,
            React.createElement(sok_ui_1.Dropdown2MenuItem, { className: 'bottom-bar', key: 'bottom-bar', onClick: function () {
                    if (props.searchDropdownToggled === true) {
                        props.toggleSearchDropdown();
                    }
                    if (props.advancedSearchDropdownToggled === false) {
                        props.toggleAdvancedSearchDropdown();
                    }
                } },
                React.createElement("div", null,
                    React.createElement("span", null, (0, translation_1.getLocalization)('userfront/project/files/targetYourSearch/SearchDropdownContainer/moreSearchTools')))))));
});
var SearchResultDropdownEnhance = (0, recompose_1.compose)((0, recompose_1.lifecycle)({
    shouldComponentUpdate: function (nextProps) {
        if (this.props.searchData.status !== nextProps.searchData.status ||
            (this.props.searchData.files !== nextProps.searchData.files &&
                this.props.searchData.files.length !==
                    nextProps.searchData.files.length) ||
            this.props.currentProject !== nextProps.currentProject) {
            return true;
        }
        return false;
    }
}), recompose_1.pure);
var SearchResultDropdown = SearchResultDropdownEnhance(function (props) {
    if (props.searchData.status === 'FETCHING') {
        return (React.createElement("div", { className: 'search-placeholder' },
            React.createElement(sok_ui_1.LoadingSpinner, null)));
    }
    if (props.searchData.status === 'FAILED') {
        return (React.createElement("div", { className: 'search-placeholder' },
            React.createElement("span", null, (0, translation_1.getLocalization)('userfront/project/files/targetYourSearch/messages/error'))));
    }
    if (props.searchData.status === 'FETCHED') {
        if (props.searchData.files.length === 0) {
            return (React.createElement("div", { className: 'search-placeholder' },
                React.createElement("span", null, (0, translation_1.getLocalization)('userfront/project/files/targetYourSearch/messages/noResults'))));
        }
        return (React.createElement(React.Fragment, null, props.searchData.files.sort(sortQuickSearch).map(function (data) { return (React.createElement(sok_ui_1.Dropdown2MenuItem, { className: "sok-search-file-list-row file-item", key: data.id },
            React.createElement("div", { className: "item-link", onClick: function () {
                    props.setSearchString(data.name);
                    props.toggleSearchDropdown();
                } },
                (0, FileIcon_1.typeToIconAndTextMap)(data.type).icon,
                React.createElement("div", { className: "file-name" },
                    React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, data.path) }, React.createElement("span", null, data.name)))),
            React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, (0, translation_1.getLocalization)('fileslist/listrow/gotoFolder')) },
                React.createElement(react_router_dom_1.Link, { to: props.baseUrl.replace(/\/[^\/]*$/, '/' + data.parent) },
                    React.createElement(components_1.TableRowIcon, { className: "narrow", icon: 'fa-angle-double-right' }))))); })));
    }
    return null;
});
exports.FileListSearchBar = enhance(function (props) {
    var searchFieldRef = React.useRef(null);
    React.useEffect(function () {
        function handleResize() {
            if (searchFieldRef.current) {
                props.setWidth(searchFieldRef.current.getBoundingClientRect().width);
            }
        }
        window.addEventListener('resize', handleResize);
        return function () {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    return (React.createElement(sok_ui_1.Grid.Row, { className: 'sok-search-bar-content file-list-search-bar' },
        React.createElement(sok_ui_1.Grid.Column, { extraSmall: 12 },
            props.displayProjectSelector && (React.createElement(ProjectSelector_1.ProjectSelector, { navigateToProject: props.navigateToProject })),
            React.createElement("div", { className: 'search-area' },
                React.createElement(sok_ui_1.Dropdown2, { className: 'sok-search-dropdown-container', alignment: 'center', isOpen: props.searchDropdownToggled || props.advancedSearchDropdownToggled, onChange: function (value, e) {
                        var elem = e.target;
                        while (elem) {
                            if (elem.classList.contains('sok-dropdown2-menu') ||
                                elem.classList.contains('file-list-search-box-right')) {
                                return;
                            }
                            elem = elem.parentElement;
                        }
                        if (props.advancedSearchDropdownToggled === true) {
                            // close if requested to be closed and original propagator is in DOM
                            // so that it didn't happen by "accident" (ie. hokalekoodaus)
                            // by our beloved "senior" programmers.
                            if (e.target &&
                                e.target.parentNode &&
                                value !== props.advancedSearchDropdownToggled) {
                                return props.toggleAdvancedSearchDropdown();
                            }
                            return;
                        }
                        if (value === true && !props.searchDropdownToggled) {
                            if (props.searchOptions.searchFileType.isSome() ||
                                props.inputValue.length > 0) {
                                (0, exports.onSearchStringChange)(props.inputValue, props);
                                if (props.searchOptions.moreSearch) {
                                    props.toggleAdvancedSearchDropdown();
                                }
                                else {
                                    props.toggleSearchDropdown();
                                }
                            }
                            else {
                                if (props.searchOptions.moreSearch) {
                                    props.toggleAdvancedSearchDropdown();
                                }
                                else {
                                    props.toggleSearchDropdown();
                                }
                            }
                        }
                        else if (value === false && props.searchDropdownToggled) {
                            props.toggleSearchDropdown();
                        }
                    } },
                    React.createElement("div", { className: 'dropdown-input', ref: searchFieldRef },
                        React.createElement(sok_ui_1.TextInput, { placeholder: (0, translation_1.getLocalization)('userfront/project/files/fileListSearchBar'), className: "search-box white", value: props.inputValue, onKeyPress: (0, exports.onKeyPress)(props), onChange: function (e) {
                                return (0, exports.onSearchStringChange)(e.target.value, props);
                            }, icon: React.createElement(SearchBoxLeft_1.SearchBoxLeft, { key: "icon", onSearchFiles: props.onSearchFiles, searchOptions: props.searchOptions, toggleSearchDropdown: props.toggleSearchDropdown, searchDropdownToggled: props.searchDropdownToggled, changeToCurrentFolder: props.changeToCurrentFolder, setSearchType: props.setSearchType, toggleMoreSearch: props.toggleMoreSearch, clearSearchFileTypeClicked: props.clearSearchFileTypeClicked, onClearAll: props.clearAll }), iconRight: React.createElement(SearchBoxRight_1.SearchBoxRight, { key: "right-icon", onDropdownCadetClick: (0, exports.onDropdownCadetClick)(props), searchFilterToggled: props.searchOptions.searchString !== '' ||
                                    props.searchOptions.searchFileType.isSome(), onResetSearchOptions: props.onResetSearchOptions, changeToCurrentFolder: props.changeToCurrentFolder }) })),
                    React.createElement(sok_ui_1.Dropdown2Menu, { className: 'file-list-dropdown', style: {
                            minWidth: "".concat(props.width, "px")
                        } }, props.searchDropdownToggled ? ((function () {
                        if (props.searchOptions.searchFileType.isSome() ||
                            props.inputValue.length >= 3) {
                            return React.createElement(SearchResultDropdown, __assign({ key: 'result' }, props));
                        }
                        return React.createElement(SearchDropdown, __assign({ key: 'type-select' }, props));
                    })()) : props.advancedSearchDropdownToggled ? (React.createElement(AdvancedDropdown, __assign({ key: 'advanced' }, props))) : null))))));
});
